export default (editor, { defaultModel, defaultView, ...config }) => {
  const type = 'slider'
  const { attrSlider, classSlider } = config

  editor.DomComponents.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Slider',
        draggable: ':not(.slider)',
        droppable: ':not(.slider)',
        'attr-slider': config.attrSlider,
        'attr-slider-item': config.attrSliderItem,
        'attr-slider-dots': config.attrSliderDots,
        'attr-slider-dot': config.attrSliderDot,
        'attr-slider-prev': config.attrSliderPrev,
        'attr-slider-next': config.attrSliderNext,
        'class-slide-active': config.classSlideActive,
        'class-dot-active': config.classDotActive,
        ...config.sliderProps
      },
      init() {
        const attrs = this.getAttributes()
        attrs[config.attrSlider] = 1
        this.setAttributes(attrs)
        classSlider && this.addClass(classSlider)
      },
      updated(target, newVal, oldVal) {
        if (target === 'components') {
          editor.Canvas.getWindow().AfrusEditor.loadSliderDots(this.view.el, 'updated')
        }
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrSlider)) {
          return { type }
        }
      }
    }),
    view: defaultView.extend({
      init() {
        const comps = this.model.components()
        !comps.length && comps.add(config.template)
      },
      onRender() {
        const slider = this.model.find(`[${config.attrSlider}]`)[0]
        slider && slider.components().each(item => {
          slider.onAdd(item)
        })
        editor.Canvas.getWindow().AfrusEditor.loadSliderDots(this.el)
        editor.Canvas.getWindow().AfrusEditor.loadSlider(this.el)
      }
    })
  })
}
